// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2l38L","title":"ClientCherryInfo_title__hLZhR","itemText":"ClientCherryInfo_itemText__1bHlG"};